import { useEffect } from "react";

const TRACEABLE_PROTOCOLS = new Set(["http:", "https:"]);

export function shouldInitializeBrowserTracing(protocol: string) {
  return TRACEABLE_PROTOCOLS.has(protocol);
}

/**
 * Client boundary that starts the shared frontend observability stack.
 *
 * It owns no orchestration of its own — Web Vitals, browser tracing,
 * OpenObserve RUM and browser logs all come from one initializer under
 * the `public-site` policy (views, Web Vitals and errors; replay 0%).
 *
 * The import stays dynamic so no telemetry code sits in a marketing page's
 * first-paint bundle.
 */
export function ObservabilityInit() {
  useEffect(() => {
    if (!shouldInitializeBrowserTracing(window.location.protocol)) return;

    void import("@/lib/observability")
      .then(({ initLandingObservability }) => {
        initLandingObservability();
      })
      .catch(() => {
        document.documentElement.dataset.browserTracing = "unavailable";
      });
  }, []);

  return null;
}
